import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SelectInput, Pagination } from "../../Components";
import OrderItem from "./OrderItem";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";

const selectDescList = [
  { id: "30days", value: "30 days" },
  { id: "3month", value: "3 Month" },
  { id: "2025", value: "2025" },
  { id: "2024", value: "2024" },
];

export default function Order({
  orderDetails = [],
  paginationData = {},
  isloaded = false,
  onPaginate,
  user,
  goToPricing,
}) {
  const [selectDesc, setselectDesc] = useState(selectDescList[0].value);
  const [isUserHasSubscription, setUserHasSubscription] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setUserHasSubscription(
      user !== null ? user.data.isUserHasSubscription === 1 : false
    );
  }, [user]);

  const changeMediumDesc = (item) => {
    setselectDesc(item.id);
  };

  const showOrderDetails = (id) => {
    navigate("/brand/orderDetails/" + id, { state: { fromTab: 'orders' } });
  };

  return (
    <>
      {isUserHasSubscription === true && (
        <>
          {isloaded && (
            <div className="billing dashboard">
              <div className="billing__table-title orderFilter">
                <h4>{paginationData.total || 0} orders placed in </h4>
                <div className="">
                  <SelectInput
                    list={selectDescList}
                    selected={selectDescList[0]}
                    onChange={changeMediumDesc}
                  />
                </div>
              </div>
              <div className="billing__table">
                <table>
                  <thead>
                    <tr>
                      <th>Order Date</th>
                      <th>Amount</th>
                      <th>Offers</th>
                      <th>Status</th>
                      <th>Order No.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails && orderDetails.length > 0 ? (
                      <>
                        {orderDetails.map((item, index) => {
                          return (
                            <OrderItem
                              showOrderDetails={showOrderDetails}
                              key={index}
                              {...item}
                            />
                          );
                        })}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                          No records
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="billing__table-footer paginationEnd">
                {orderDetails && orderDetails.length > 0 && (
                  <Pagination
                    perPage={paginationData["per_page"]}
                    total={paginationData["total"]}
                    currentPage={paginationData["current_page"]}
                    totalPages={paginationData["total_pages"]}
                    onPaginate={onPaginate}
                  />
                )}
              </div>
            </div>
          )}
        </>
      )}
      {isUserHasSubscription === false && user !== null && (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            title={"Orders"}
            background={"background_orders.png"}
          />
        </>
      )}
    </>
  );
}
